import React from 'react';
import PropTypes from 'prop-types';

// components
import ComponentLoader from '../../global/ComponentLoader/ComponentLoader';

function importFunc() {
    return import(/* webpackChunkName: "PdpSharedReminderWrapper" */
    './PdpSharedReminderWrapper').then(moduleExport => moduleExport.default);
}

const PdpSharedReminderLoader = props => {
    return (
        <ComponentLoader
            {...props}
            useLoadingComponent={false}
            importFunc={importFunc}
            load={props.load}
        />
    );
};

PdpSharedReminderLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};

export default PdpSharedReminderLoader;
